import { AJAX_TIMEOUT_MESSAGE, showManagerOverlay, withOverlayLoader } from '../helpers.js';
import { openIndexPage } from '../members/member-open-index-page.js';
import { memberPages } from '../members/member-nav-config.js';
import { getManagerNavAction } from '../manager/manager-nav-registry.js';
import { pathOf } from './router.js';
import { resolveShowAlertMsg } from './resolve-show-alert-msg.js';

function isManagerPath(url) {
    const path = pathOf(url);
    const normalized = '/' + path.replace(/^\/+/, '');
    return /\/(?:[^/]+\/)?manager(?:\/|$)/.test(normalized)
        || path.replace(/^\/+/, '').startsWith('internal/manager');
}

function onMemberShell() {
    return document.getElementById('index_paging') !== null;
}

function onManagerShell() {
    return document.getElementById('mgr_index_paging') !== null;
}

function memberHomePath() {
    try {
        const home = memberPages().home;
        if (typeof home === 'string' && home !== '') {
            return pathOf(home);
        }
    } catch (err) {
        return '';
    }
    return '';
}

function isMemberHomeUrl(url) {
    const home = memberHomePath();
    if (home === '') {
        return false;
    }
    return pathOf(url) === home;
}

function isManagerHomeUrl(url) {
    const path = pathOf(url).replace(/\/+$/, '');
    return /\/[^/]+\/manager$/.test(path) || path.endsWith('/manager');
}

function showNavError(message) {
    const showAlertMsg = resolveShowAlertMsg();
    if (typeof showAlertMsg === 'function') {
        showAlertMsg(message, 'danger');
        return;
    }
    window.alert(message);
}

export function redirectWithOverlay(url) {
    const target = String(url || '').trim();
    if (target === '') {
        throw new Error('redirectWithOverlay: url is required');
    }

    showManagerOverlay();
    window.location.assign(target);
}

export function navigateAuthRedirect(url) {
    const target = String(url || '').trim();
    if (target === '') {
        return;
    }

    if (onMemberShell() && !isManagerPath(target) && isMemberHomeUrl(target)) {
        openIndexPage();
        return;
    }

    if (onManagerShell() && isManagerPath(target) && isManagerHomeUrl(target)) {
        try {
            getManagerNavAction('openMgrIndexPage')();
            return;
        } catch (err) {
            redirectWithOverlay(target);
            return;
        }
    }

    redirectWithOverlay(target);
}

export function postRoleSwitch(url, csrfToken) {
    const target = String(url || '').trim();
    if (target === '') {
        throw new Error('postRoleSwitch: url is required');
    }

    const token = String(
        csrfToken
        || (window.jQuery ? window.jQuery('meta[name="csrf-token"]').attr('content') : '')
        || ''
    ).trim();

    const loader = withOverlayLoader({
        url: target,
        type: 'POST',
        data: token !== '' ? { _token: token } : {},
        showOverlayImmediately: true,
        deferHide: true,
        success(data) {
            if (!data || data.success === false) {
                loader.hide();
                showNavError((data && data.error) || AJAX_TIMEOUT_MESSAGE);
                return;
            }
            if (typeof data.redirect === 'string' && data.redirect !== '') {
                navigateAuthRedirect(data.redirect);
                return;
            }
            loader.hide();
            showNavError(AJAX_TIMEOUT_MESSAGE);
        },
        error(xhr) {
            loader.hide();
            const json = xhr && xhr.responseJSON;
            if (json && typeof json.error === 'string' && json.error !== '') {
                showNavError(json.error);
                return;
            }
            showNavError(AJAX_TIMEOUT_MESSAGE);
        },
    });

    return loader;
}
